export default function analytics() {
    const metaTag = document.querySelector('meta[name="ga-measurement-id"]');
    const sessionIdStorageKey = 'ga_session_id';

    if (!metaTag) {
        console.error('Meta-тег GA_MEASUREMENT_ID отсутствует.');
        return;
    }

    const measurementId = metaTag.getAttribute('content');

    if (!measurementId) {
        console.error('GA_MEASUREMENT_ID пустой.');
        return;
    }

    if (typeof gtag === 'undefined') {
        console.error('gtag не инициализирован');
        return;
    }

    const storeSessionId = (sessionId) => {
        window.GA_SESSION_ID = sessionId;
        try {
            window.sessionStorage.setItem(sessionIdStorageKey, String(sessionId));
        } catch (error) {
            console.error('Ошибка сохранения session_id:', error);
        }
    };

    const notifySessionIdReady = (sessionId) => {
        if (typeof window.CustomEvent !== 'function') {
            return;
        }

        window.dispatchEvent(new CustomEvent('ga-session-id-ready', {
            detail: {
                sessionId,
            },
        }));
    };

    const sendAnalyticsPayload = (payload, label) => {
        return fetch('/api/ga/store-client-id', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => console.log(`${label} сохранен:`, data))
            .catch(error => console.error('Ошибка:', error));
    };

    const resolved = {
        clientId: null,
        sessionId: null,
        clientReady: false,
        sessionReady: false,
        fallbackFired: false,
        sentClientId: false,
        sentSessionId: false,
    };

    const hasValue = (value) => value !== null && value !== undefined && value !== '';

    const buildPayload = () => {
        const payload = {};

        if (hasValue(resolved.clientId) && !resolved.sentClientId) {
            payload.client_id = resolved.clientId;
        }

        if (hasValue(resolved.sessionId) && !resolved.sentSessionId) {
            payload.session_id = resolved.sessionId;
        }

        return payload;
    };

    const markSent = (payload) => {
        if (Object.prototype.hasOwnProperty.call(payload, 'client_id')) {
            resolved.sentClientId = true;
        }
        if (Object.prototype.hasOwnProperty.call(payload, 'session_id')) {
            resolved.sentSessionId = true;
        }
    };

    const maybeSendIdentifiers = () => {
        if (!resolved.clientReady || !resolved.sessionReady) {
            if (!resolved.fallbackFired) {
                return;
            }
        }

        const payload = buildPayload();

        if (Object.keys(payload).length === 0) {
            if (resolved.clientReady && resolved.sessionReady) {
                console.error('Client ID и Session ID отсутствуют');
            }
            return;
        }

        sendAnalyticsPayload(payload, 'GA идентификаторы');
        markSent(payload);
    };

    setTimeout(() => {
        resolved.fallbackFired = true;
        maybeSendIdentifiers();
    }, 2000);

    gtag('get', measurementId, 'client_id', (clientId) => {
        resolved.clientReady = true;

        if (!clientId) {
            console.error('Не удалось получить client_id');
            maybeSendIdentifiers();
            return;
        }

        resolved.clientId = clientId;
        maybeSendIdentifiers();
    });

    gtag('get', measurementId, 'session_id', (sessionId) => {
        resolved.sessionReady = true;

        if (!hasValue(sessionId)) {
            console.error('Не удалось получить session_id');
            maybeSendIdentifiers();
            return;
        }

        resolved.sessionId = sessionId;
        storeSessionId(sessionId);
        notifySessionIdReady(sessionId);
        maybeSendIdentifiers();
    });
}
